import { getInitialDates } from "../../../../utils/hiringPlan";
import { getCurrentAcademicYear } from "../../../../utils/smallHelpers";
import {SET_FORM_DATA} from "../hiringPlanReducer";
import moment from 'moment'


const { from_date, to_date } = getInitialDates()

const initialState = {
    year: moment().year(),
    from_date,
    to_date,
    idorg: "0",
    school: "0"
};

export const formReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FORM_DATA:
            return action.payload;
        default:
            return state;
    }
};
